import { atom } from 'jotai';

export const aboutProfessionalLogoElementAtom = atom<HTMLDivElement | null>(
    null
);

export const footerElementAtom = atom<HTMLElement | null>(null);
